<template>
<div >
    <v-card>
        <v-card-title v-html="header">
        </v-card-title>

        <v-card-text  :class="$style.vCard">
            <v-form v-model="valid_form" ref="form">
                <div :class="$style.questions" v-html="body"/>
                <div v-html="subtext"/>

                <div v-for="(group, row) in question.config.groups" :key="'group_'+group.id">
                    <div :key="'question_id_'+question.config.id+'_'+row" :class="$style.answers">
                        <div v-html="group.label[$language()]" :class="$style.answersGroupLabel" />
                        <template v-for="column in columns(group)">
                            <div 
                                :key="'row_'+row+'_column_'+column.id" 
                                id="answerBox"
                                :class="[$style.answerBox,{[$style.disabled]:!column.enabled}]" 
                                >
                                <template>
                                    <span v-html="column.label[$language()]" />
                                    <v-select 
                                        v-model="value[group.id][column.id]" 
                                        :items="selectOptions(group)" 
                                        outlined 
                                        :disabled="!column.enabled">
                                        <template v-slot:item="{ item }">
                                            <span v-html="item.text" :class="$style.selectItemLabel" />
                                        </template>
                                        <template v-slot:selection="{ item }">
                                            <span v-html="item.text" :class="$style.selectItemLabel" />
                                        </template>
                                    </v-select>
                                </template>
                                <!-- <span v-else v-html="'&ndash;'"/> -->
                            </div>
                        </template>
                    </div>
                </div>
            </v-form>
        </v-card-text>

        <v-card-text v-html="footer">
        </v-card-text>
    </v-card>
</div>
</template>

<script>
const controller = require("./controllers/selectTable.js").default;
const module_generator = require("./controllers/module_generator.js").default;

var module_config = module_generator('select-table-question',controller);
export default module_config;
module_config.methods.columns = function(group){
    return group.type_config[this.question.config.type].items;
}

module_config.methods.selectOptions = function(group){
    var options = [];
    for(let i=0; i<group.inputs.length; i++){
        var input = group.inputs[i];
        options.push({
            text: (this.survey.mode=='dev' ? "["+input.value+"] " : '') + input.label[this.$language()],
            value: input.value
        })
    }

    return options;
}
</script>

<style module>
.vCard {
    padding: 16px;
    width: 100%;
}

.answers {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}

.answersGroupLabel {
    position: relative; 
    min-width: 150px;
    width: auto; 
    margin: 15px; 
    border-bottom: 0px solid grey; 
    font-size: 1.2em;
}

.answerBox {
    min-width:25px;
    min-height: 25px; 
    padding: 12px; 
    margin: 5px;
    max-width: 500px;
    width: auto;
    text-align:center;
    flex: 1 1 0px
}

.answerBox p {
    margin-bottom: 0px !important;
}
.question{
    border: 1px solid slategray;
    border-radius: 3px;
    margin: 25px;
    padding: 15px;
}

.questions {
    font-size:18px;
    margin: 0px 0px 20px;
    color:black;
}

.disabled{
    opacity: 0.2;
}

.selectItemLabel p {
    margin-bottom: 0px !important;
}

.selectItemLabel + input {
    display: none;
}

@media only screen and (max-width: 1240px) {
    .vCard {
        padding: 0 100px;
    }

    .answerBox {
        width: 230px;
    }
}

@media only screen and (max-width: 1145px) {
    .vCard {
        padding: 0 80px;
    }
}

@media only screen and (max-width: 1105px) {
    .vCard {
        padding: 0 30px;
    }
}

@media only screen and (max-width: 1000px) {
    .vCard {
        padding: 0 10px;
    }
}

@media only screen and (max-width: 980px) {

.vCard {
    margin: 0px !important;
    width: 100%;
    padding: 0px 10px;
}

.answerBox {
    width: 200px;
}

.questions {
    width: 95%;
    margin:0px !important;
}

}
</style>

<style>
#answerBox .v-text-field--outlined>.v-input__control>.v-input__slot {
    /* min-height:56px !important; */
}

#answerBox .v-text-field.v-text-field--enclosed .v-input__append-inner {
    margin-top: 10px !important;
}
</style>


